import { SkeletonBlock } from '~/shared/ui'

export function LoadingSkeleton() {
  return (
    <div className="px-6 py-4">
      <div className="flex flex-col gap-6">
        <div className="grid gap-6">
          <div className="flex flex-col gap-3">
            <SkeletonBlock className="h-5" />
            <SkeletonBlock className="h-[52px]" />
          </div>
          <div className="flex flex-col gap-3">
            <SkeletonBlock className="h-5" />
            <SkeletonBlock className="h-[52px]" />
          </div>
        </div>
        <div className="flex flex-col gap-3">
          <SkeletonBlock className="h-5" />
          <SkeletonBlock className="h-[52px]" />
        </div>
      </div>
    </div>
  )
}
